import { defineMessages } from 'react-intl'

const messages = defineMessages({
  businessBehavior: {
    id: 'ContentChartWrapper.businessBehavior',
    description: 'Texto para el primer epígrafe del nivel 3',
    defaultMessage: 'Comportamiento empresarial'
  },
  specialization: {
    id: 'ContentChartWrapper.specialization',
    description: 'Texto para el segundo epígrafe del nivel 3',
    defaultMessage: 'Especialización'
  },
  businessEnvironment: {
    id: 'ContentChartWrapper.businessEnvironment',
    description: 'Texto para el tercer epígrafe del nivel 3',
    defaultMessage: 'Entorno empresarial'
  }
})

export default messages



// WEBPACK FOOTER //
// ./src/modules/Content/ContentChart/ContentChartWrapper/messages.js